import idProofEvents from "./events/IDProofEvents";
import modalAccessibility from "core-ui/client/src/app/ModalAccessibility";

var IDProofConsentController = function (
    $scope,
    param,
    $injector,
    $modalInstance,
    idProofFactory,
    redirectService,
    eventBus
) {
    var vm = this;
    var $state = $injector.get("$state");
    var $timeout = $injector.get("$timeout");
    $scope.isOTSUser = param === "verifyIdentity" ? true : false;

    modalAccessibility.onOpenModal(".modal-content");

    var idProofConsent = {
        ssn: "yes"
    };

    vm.onConfirmClick = function () {
        eventBus.dispatch(idProofEvents.CONFIRM_CONSENT, this);

        idProofFactory.optInConsent.query(
            {},
            function (data, headers) {
                $modalInstance.close();
                redirectService.redirect(data, "ALL");
            },
            function (error) {
                $modalInstance.close();
            }
        );
    };

    vm.onCancelClick = function () {
        $state.go("mailPin", { optOut: "optOut-Modal" });
        $modalInstance.close();
    };
};

IDProofConsentController.$inject = [
    "$scope",
    "param",
    "$injector",
    "$modalInstance",
    "idProofFactory",
    "redirectService",
    "eventBus"
];
export default IDProofConsentController;
